/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Supplement_WordsInputs */

const en_us2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey supplement creatine`)
};

const pt_br2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey suplemento creatina`)
};

const es_419_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey suplemento creatina`)
};

const pt_pt2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey suplemento creatina`)
};

const fr_fr2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey complement creatine supplement`)
};

const de_de2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey supplement kreatin nahrungsergänzung`)
};

const it_it2_search_field_supplement_words = /** @type {(inputs: Search_Field_Supplement_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whey integratore integratori creatina`)
};

/**
* | output |
* | --- |
* | "whey supplement creatine" |
*
* @param {Search_Field_Supplement_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_supplement_words = /** @type {((inputs?: Search_Field_Supplement_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Supplement_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_supplement_words(inputs)
	if (locale === "es-419") return es_419_search_field_supplement_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_supplement_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_supplement_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_supplement_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_supplement_words(inputs)
	return en_us2_search_field_supplement_words(inputs)
});
export { search_field_supplement_words as "search.field_supplement_words" }